import type { FeatureUnlock } from "@indietabletop/types";
import { vars } from "../vars.css";
import { useIsFeatureUnlocked } from "./useIsFeatureUnlocked";

export function CoreRulesText(props: { children: string }) {
  return (
    <PremiumText feature="GREATHELM_CORE_RULES">{props.children}</PremiumText>
  );
}

export function PremiumText(props: {
  children: string;
  feature: FeatureUnlock["feature"];
}) {
  const { children, feature } = props;
  const canAccessCoreRules = useIsFeatureUnlocked(feature);

  if (!canAccessCoreRules) {
    const dummyText =
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
    return (
      <span style={{ fontFamily: vars.font.redactedScript }}>
        {dummyText.slice(0, children.length)}
      </span>
    );
  }

  return <span>{children}</span>;
}

import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { href } from "../App/href";
import { brookshire } from "../common.css";
import imageSrc from "./dagger.webp";

export function PremiumContentDividerNote(props: { backTo: string }) {
  const { backTo } = props;

  const login = (
    <Link
      href={href("~/login", { search: { backTo } })}
      className={interactiveText}
    >
      login
    </Link>
  );

  const join = (
    <Link
      href={href("~/join", { search: { backTo } })}
      className={interactiveText}
    >
      join
    </Link>
  );

  const buy_the_rules = (
    <Link
      href={href("~/shop", { search: { backTo } })}
      className={interactiveText}
    >
      Buy the rules
    </Link>
  );

  return (
    <div style={{ textAlign: "center", marginBlock: "2rem" }}>
      <div style={{ fontSize: "1.75rem" }} className={brookshire}>
        Hold up!
      </div>

      <div
        style={{
          marginBlock: "0.25lh 2rem",
          lineHeight: 1.5,
          fontSize: "1.125rem",
        }}
      >
        Following options are only available if you own Greathelm. Backed on
        Kickstarter? Continue to {login} or {join} to get access. New to the
        game? {buy_the_rules}.
      </div>

      <img
        src={imageSrc}
        alt=""
        style={{
          inlineSize: "min(16rem, 100%)",
          marginInline: "auto",
          marginBlockEnd: "2rem",
        }}
      />
    </div>
  );
}
